import Service, { getCallApiFunction } from '../service'
import { helpCountryHeader } from '../fetchHelpArticle'

export type HelpReaction = 'up' | 'neutral' | 'down'

export interface IParams {
  id: number
  countryCode: string
  reaction: HelpReaction
  /** 未登入時用來辨識同一位投票者（與最近看過、UTM 共用的訪客 uuid） */
  visitorId: string
}

// 幫助中心文章評價：同一位投票者可以改票；有登入時後端以會員記票
class ReactHelpArticleApi extends Service {
  constructor({ id, countryCode, reaction, visitorId }: IParams) {
    super()
    this.name = 'REACT_HELP_ARTICLE'

    this.config = {
      url: `/v1/help/articles/${id}/reaction`,
      method: 'POST',
      data: { reaction, visitorId },
      headers: helpCountryHeader(countryCode),
    }
  }
}

export const reactHelpArticle = (params: IParams) => getCallApiFunction(new ReactHelpArticleApi(params))
